<qr-overlay-topbar (close)="close.emit()">
  Detalle de la reserva
</qr-overlay-topbar>

<div class="preview">
  <div class="preview__container">
    <div class="preview__item">
      <div class="preview__title">
        <p>Propiedad</p>
      </div>
      <div class="preview__data">
        <div class="preview__column preview__address">
          <p class="preview__subtitle">Dirección</p>
          <p class="preview__info">{{ reservation.address }}</p>
        </div>
        <div class="preview__column preview__mls">
          <p class="preview__subtitle">MLS-ID</p>
          <p class="preview__info">{{ reservation.mlsid }}</p>
        </div>
      </div>
    </div>
    <div class="preview__item">
      <div class="preview__title">
        <p>Datos de la operación</p>
      </div>
      <div class="preview__data">
        <div class="preview__column preview__column--operation">
          <p class="preview__subtitle">Fecha</p>
          <p class="preview__info">
            {{ this.utils.getFormattedDate(reservation.createdDate) }}
          </p>
        </div>
        <div class="preview__column preview__column--operation">
          <p class="preview__subtitle">Operación</p>
          <p class="preview__info">{{ reservation.operationTypeName }}</p>
        </div>
        <div class="preview__column preview__column--operation">
          <p class="preview__subtitle">Ticket</p>
          <p class="preview__info">
            {{ currencySymbol }}
            {{ reservation.price | number : "1.0-2" }}
          </p>
        </div>
        <div class="preview__column preview__column--operation-last">
          <p class="preview__subtitle">Tipo de cambio</p>
          <p class="preview__info" *ifNodeHide="[NODE_EC]">$ {{ reservation.exchangeRate }}</p>
          <p class="preview__info" *ifNodeShow="[NODE_EC]">-</p>
        </div>
      </div>
    </div>
    <!-- DETALLES DE LA RESERVA -->
    <div class="preview__item">
      <div class="preview__title">
        <p>Detalles de la reserva</p>
      </div>
      <div class="preview__data">
        <div class="preview__column preview__column--state">
          <p class="preview__subtitle">Estado</p>
          <p class="preview__info">{{ reservation.reservationStateName }}</p>
        </div>
        <div class="preview__column preview__column--type">
          <p class="preview__subtitle">Tipo de contrato</p>
          <p class="preview__info">
            {{ reservation.captationType == 1 ? "Exclusiva" : "No exclusiva" }}
          </p>
        </div>
        <div class="preview__column preview__column--date-closed">
          <p class="preview__subtitle">Fecha estimada cierre</p>
          <p class="preview__info">
            {{ this.utils.getFormattedDate(reservation.estimateCloseDate) }}
          </p>
        </div>
        <div class="preview__column preview__column--active">
          <p class="preview__subtitle">Activa</p>
          <p class="preview__info">{{ reservation.active ? "Sí" : "No" }}</p>
        </div>
        <div class="preview__column preview__column--shared">
          <p class="preview__subtitle">Compartida al 50%</p>
          <p class="preview__info">{{ reservation.shared ? "Sí" : "No" }}</p>
        </div>
      </div>
    </div>
    <!-- DETALLES DEL AGENTE VENDEDOR -->
    <div class="preview__item">
      <div class="preview__title">
        <p>Detalles del agente {{ NODE === NODE_DO ? 'captador' : 'vendedor' }}</p>
      </div>
      <div class="preview__data">
        <div class="preview__column preview__column--agent">
          <p class="preview__subtitle">Nombre</p>
          <p class="preview__info">
            {{ reservation.organizationNameVendedor }}
          </p>
        </div>
        <div class="preview__column preview__column--agent">
          <p class="preview__subtitle">Comisión</p>
          <p class="preview__info">
            <ng-container
              *ngIf="reservation.percentageComitionVendedor; else noVendPercent"
            >
              {{ reservation.percentageComitionVendedor | number : "1.0-2" }}%
            </ng-container>
            <ng-template #noVendPercent>-</ng-template>
            /
            <ng-container
              *ngIf="reservation.amountComitionVendedor; else noVendTotal"
            >
              {{ currencySymbol }}
              {{ reservation.amountComitionVendedor | number : "1.0-2" }}
            </ng-container>
            <ng-template #noVendTotal>-</ng-template>
          </p>
        </div>

        <div class="preview__column preview__column--agent-last">
          <p class="preview__subtitle">Origen cliente</p>
          <p class="preview__info">{{ customerOriginSale }}</p>
        </div>
      </div>
    </div>
    <!-- DETALLES DEL AGENTE COMPRADOR -->
    <div class="preview__item">
      <div class="preview__title">
        <p>Detalles del agente {{ NODE === NODE_DO ? 'vendedor' : 'comprador' }}</p>
      </div>
      <div class="preview__data">
        <div class="preview__column preview__column--agent">
          <p class="preview__subtitle">Nombre</p>
          <p class="preview__info">
            {{ reservation.organizationNameComprador }}
          </p>
        </div>
        <div class="preview__column preview__column--agent">
          <p class="preview__subtitle">Comisión</p>
          <p class="preview__info">
            <ng-container
              *ngIf="reservation.percentageComitionComprador; else noPercent"
            >
              {{ reservation.percentageComitionComprador | number : "1.0-2" }}%
            </ng-container>
            <ng-template #noPercent>-</ng-template>
            /
            <ng-container
              *ngIf="reservation.amountComitionComprador; else noTotal"
            >
              {{ currencySymbol }}
              {{ reservation.amountComitionComprador | number : "1.0-2" }}
            </ng-container>
            <ng-template #noTotal>-</ng-template>
          </p>
        </div>

        <div class="preview__column preview__column--agent-last">
          <p class="preview__subtitle">Origen cliente</p>
          <p class="preview__info">{{ customerOriginPurchase }}</p>
        </div>
      </div>
    </div>
    <!-- COMISIÓN OFICINA -->
    <div class="preview__item">
      <div class="preview__title">
        <p>Comisión oficina</p>
      </div>
      <div class="preview__data">
        <div class="preview__column preview__column--comission">
          <p class="preview__subtitle">Porcentaje</p>
          <p class="preview__info">
            {{
              reservation.percentageComition
                ? reservation.percentageComition + "%"
                : "-"
            }}
          </p>
        </div>
        <div class="preview__column preview__column--comission-last">
          <p class="preview__subtitle">Monto</p>
          <p class="preview__info">
            <ng-container
              *ngIf="
                reservation.totalComition !== null &&
                  reservation.totalComition !== undefined;
                else noTotal
              "
            >
            {{ currencySymbol}}  
            {{ reservation.totalComition | number : "1.0-2" }}
            </ng-container>
            <ng-template #noTotal>-</ng-template>
          </p>
        </div>
      </div>
    </div>
    <!-- DETALLES -->
    <div class="preview__item">
      <div class="preview__title">
        <p>Detalles</p>
      </div>
      <div class="preview__data--last">
        <div class="preview__column">
          <p class="preview__subtitle">Notas</p>
          <p class="preview__info--notes" [matTooltip]="reservation.notes">
            {{ reservation.notes.trim() ? reservation.notes : "-" }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="preview__actions">
    <qr-button [config]="buttonGoBack" (click)="closeDialog()"></qr-button>
  </div>
</div>
